/* eslint-disable */

import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// import './build/element-variables.scss'
import '../public/static/css/nucleusTheme/index.css'
import '../public/static/css/element-input-number-fix.css'
import HiaLoading from './components/HiaLoading'
import clientNavSelector from '@/components/clientNavSelector'
import { ClientTable, ServerTable } from 'vue-tables-2'
import AuthService from './auth/AuthService'
import HiaVueTable2 from './components/HiaVueTable2'
import PortalVue from 'portal-vue'

const auth = new AuthService()

Vue.config.productionTip = false

Vue.use(PortalVue)
Vue.use(ElementUI, { locale: locale, size: 'mini' })

Vue.use(ClientTable, {
  texts: {
    defaultOption: 'Select All',
    filter: '',
    filterBy: '...'
  },
  filterByColumn: true,
  perPage: 20,
  highlightMatches: true,
  sortIcon: { is: 'none' },

}, false, 'bootstrap3', { dataTable: HiaVueTable2 })
Vue.use(ServerTable, {
  texts: {
    defaultOption: 'Select All'
  }
}, false, 'bootstrap3', { dataTable: HiaVueTable2 })

Vue.component('hia-loading', HiaLoading)
Vue.component('clientNavSelector', clientNavSelector)


function main() {
  checkAuth()
  initializeAppInsights()
}

function checkAuth() {
  auth.authNotifier.on('authChange', authState => {
    if (authState.authenticated) {
      // redirect the user back to the original route after the Auth0 login and callback process is finished
      let redirectPath = window.localStorage.getItem('redirectPath')
      if (redirectPath) {
        window.history.replaceState(null, null, redirectPath)
      }
      setUser()
    }
  })

  // if this is a callback from Auth0, the url will contain 'access_token'
  if (window.location.href.indexOf('access_token') > -1) {
    // Idle check happens inside handleAuthentication / login before accepting session.
    auth.handleAuthentication()
  } else {
    // Enforce idle even when the access token already expired (otherwise SSO can bypass 24h).
    if (auth.isIdleTimedOut && auth.isIdleTimedOut()) {
      auth.logout()
      return
    }

    if (!auth.isAuthenticated()) {
      // if blocked user show message
      window.localStorage.setItem('redirectPath', window.location.pathname + window.location.search + window.location.hash)
      if (window.location.href.indexOf('error_description=user%20is%20blocked') > -1) {
        showBlockedUserMessage()
        return
      }
      auth.login()
    } else {
      auth.startIdleTracking()
      auth.scheduleRenewal()
      setUser()
    }
  }
}

// app insights
function initializeAppInsights() {
  var currentURL = window.location.href
  var appInsights
  if (currentURL.startsWith('http://localhost') || currentURL.startsWith('https://hianucleus-dev')) {
    appInsights = window.appInsights || function (config) {
      function i(config) { t[config] = function () { var i = arguments; t.queue.push(function () { t[config].apply(t, i) }) } } var t = { config: config }, u = document, e = window, o = "script", s = "AuthenticatedUserContext", h = "start", c = "stop", l = "Track", a = l + "Event", v = l + "Page", y = u.createElement(o), r, f; y.src = config.url || "https://az416426.vo.msecnd.net/scripts/a/ai.0.js"; u.getElementsByTagName(o)[0].parentNode.appendChild(y); try { t.cookie = u.cookie } catch (p) { } for (t.queue = [], t.version = "1.0", r = ["Event", "Exception", "Metric", "PageView", "Trace", "Dependency"]; r.length;)i("track" + r.pop()); return i("set" + s), i("clear" + s), i(h + a), i(c + a), i(h + v), i(c + v), i("flush"), config.disableExceptionTracking || (r = "onerror", i("_" + r), f = e[r], e[r] = function (config, i, u, e, o) { var s = f && f(config, i, u, e, o); return s !== !0 && t["_" + r](config, i, u, e, o), s }), t
    }(
      {
        instrumentationKey: 'a138ffc3-72fa-498c-bd2f-e2364178ec0b'
      })
  } else {
    appInsights = window.appInsights || function (config) {
      function i(config) { t[config] = function () { var i = arguments; t.queue.push(function () { t[config].apply(t, i) }) } } var t = { config: config }, u = document, e = window, o = "script", s = "AuthenticatedUserContext", h = "start", c = "stop", l = "Track", a = l + "Event", v = l + "Page", y = u.createElement(o), r, f; y.src = config.url || "https://az416426.vo.msecnd.net/scripts/a/ai.0.js"; u.getElementsByTagName(o)[0].parentNode.appendChild(y); try { t.cookie = u.cookie } catch (p) { } for (t.queue = [], t.version = "1.0", r = ["Event", "Exception", "Metric", "PageView", "Trace", "Dependency"]; r.length;)i("track" + r.pop()); return i("set" + s), i("clear" + s), i(h + a), i(c + a), i(h + v), i(c + v), i("flush"), config.disableExceptionTracking || (r = "onerror", i("_" + r), f = e[r], e[r] = function (config, i, u, e, o) { var s = f && f(config, i, u, e, o); return s !== !0 && t["_" + r](config, i, u, e, o), s }), t
    }(
      {
        instrumentationKey: '665dcd4f-ac79-4315-a14d-e230926ee67d'
      })
  }

  window.appInsights = appInsights
  appInsights.trackPageView()
}

function setAppInsightsUser(userName) {
  if (window.appInsights) {
    appInsights.setAuthenticatedUserContext(userName, userName)
  }
}

function setUser() {
  let accessToken = window.localStorage.getItem('access_token')
  let idToken = window.localStorage.getItem('id_token')
  let parsedIdToken = parseJwt(idToken)
  let parsedAccessToken = parseJwt(accessToken)

  let user = {
    email: parsedIdToken.email,
    accessToken: accessToken,
    name: parsedIdToken.name,
    roles: [],
    auth0Id: getAuth0UserId(parsedAccessToken),
    isSsoUser: isSsoUser(parsedAccessToken),
    logout: function () {
      auth.logout()
    }
  }

  store.commit('user/SET_USER', user)
  store.dispatch('user/GET_PROFILE').then(() => {
    setTimeout(() => {
      let el = document.getElementById('nucleusLoader')
      el.className += ' fade-out'
      setTimeout(() => {
        initializeVue()
      }, 400)
    }, 2000)
  })
  setAppInsightsUser(parsedIdToken.email)
}

function getAuth0UserId(accessTokenClaims) {
  const sub = accessTokenClaims.sub
  if (sub && sub.startsWith('auth0|')) {
    return sub
  }
  return accessTokenClaims['https://nucleus.hiacode.com/internal_sub'] || sub
}

function isSsoUser(accessTokenClaims) {
  const sub = accessTokenClaims.sub
  return !sub || !sub.startsWith('auth0|')
}

function parseJwt(token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  let jwt = JSON.parse(window.atob(base64))
  return jwt
}

function showBlockedUserMessage() {
  let link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = '/static/css/auth0.css'
  document.head.appendChild(link)
  document.getElementById('loader-wrapper').innerHTML = '<div id="auth0-lock-container-1" class="auth0-lock-container"><div data-reactroot="" class="auth0-lock auth0-lock-opened"><div class="auth0-lock-center"><form class="auth0-lock-widget" method="post"><div class="auth0-lock-widget-container"><div class="auth0-lock-cred-pane auth0-lock-quiet"><div class="auth0-lock-header"><div class="auth0-lock-header-bg auth0-lock-blur-support"><div class="auth0-lock-header-bg-blur" style="background-image: url(&quot;https://nucleus.hiacode.com/static/images/nucleus-logo-poweredby.svg&quot;);"></div><div class="auth0-lock-header-bg-solid" style="background-color: rgb(0, 71, 118);"></div></div><div class="auth0-lock-header-welcome"><img class="auth0-lock-header-logo" src="https://nucleus.hiacode.com/static/images/nucleus-logo-poweredby.svg"><div class="auth0-lock-name" title="HIA Client Portal">HIA Client Portal</div></div></div><div><div></div></div><div style="position: relative;"><span><div class="" style=""><div style="visibility: inherit;"><div class="auth0-lock-view-content"><div style="position: relative;"><div class="auth0-lock-body-content"><div class="auth0-lock-content"><div class="auth0-lock-form"><div><div> <p clsas="auth0-lock-alternative" style="/* color: #333333; */color: rgb(0, 71, 118);font-weight: bold;font-size: 15px;">Your Nucleus account is locked. Please contact HIA for support.</p><p class="auth0-lock-alternative" style="margin-top: 10px;"><a class="auth0-lock-alternative-link" href="mailto:nucleus@hiacode.atlassian.net?subject=Nucleus Account Help&amp;body=Please include your name and email.">Need Account Help?</a></p><p></p></div></div></div></div></div></div></div></div></div></span></div></div></div></form></div></div></div>'
}

function initializeVue() {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

main()
